import { createSelector } from 'reselect';

// TODO (josh) : this key should come from a constant
const getOnboardingState = state => state.onboardingState;

export const getDiscussionTopics = createSelector(
  [getOnboardingState],
  onboardingState => onboardingState.discussionTopics
);

export const getFlowType = createSelector([getOnboardingState], onboardingState => onboardingState.flowType);

export const getProfile = createSelector([getOnboardingState], onboardingState => onboardingState.profile);

export const getStepIndex = createSelector([getOnboardingState], onboardingState => onboardingState.stepIndex);

export const getStep = createSelector([getOnboardingState], onboardingState => onboardingState.step);

export const getConnectedCalendar = createSelector(
  [getOnboardingState],
  onboardingState => onboardingState.connectedCalendar
);

export const getRecurringMeetings = createSelector(
  [getOnboardingState],
  onboardingState => onboardingState.recurringMeetings
);

export const getWorkspaces = createSelector([getOnboardingState], onboardingState => onboardingState.workspaces);
